import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import React from "react";
import useLoadFullPanchangData from "./customHook";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Container, Grid } from "@mui/material";

function FullCalenderPanchangSVT() {
  const { getPanchangData, fullpanchang } = useLoadFullPanchangData();

  useEffect(() => {
    getPanchangData();
    setTimeout(() => {
      document
        .querySelector(".fc-today-button")
        ?.setAttribute(
          "style",
          "background-color: #b71b00 !important; color: white !important; border: none !important;"
        );
    }, 100);
  }, []);
  return (
    <>
      <Container maxWidth={'xl'} className="page-header py-4 breadcrumb-bg">
        <h1 className="text-center display-6 breadcrumb-h1">
          Panchang ({" "}
          {new Date().toLocaleDateString("en-US", {
            timeZone: "America/New_York",
            month: "long",
            year: "numeric",
          })}{" "}
          )
        </h1>
        <ol className="breadcrumb justify-content-center mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/fullpanchang">Full Panchang</Link>
          </li>
        </ol>
      </Container>
      <Container className="py-5">
        <Grid className="row">
          <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            events={fullpanchang}
            selectable={true}
            editable={true}
            height="auto"
            eventContent={(arg) => (
              <div
                dangerouslySetInnerHTML={{
                  __html: arg.event.extendedProps.html,
                }}
              />
            )}
            buttonText={{
              today: "Today's Alamanac",
            }}
          />
        </Grid>
      </Container>
    </>
  );
}

export default FullCalenderPanchangSVT;
